import React from 'react';
import { useIntl } from 'react-intl';

import {
  FAQs,
  Hero,
  HostBenefits,
  HostExperiences,
  HostingBlogs,
  HostingOverview,
  HostingTools,
  Testimonials,
} from '@/components/route/become-a-host';
import { StartListingForm } from '@/components/route/become-a-host/RV';
import HeadMeta from '@/components/static-pages/HeadMeta';

const BecomeAHost = () => {
  const intl = useIntl();

  const title = intl.formatMessage({
    defaultMessage: 'RV - Become a host on Outdoorsy',
    id: '6/jBZf',
  });

  const description = intl.formatMessage({
    defaultMessage:
      'Find out how much you could earn when you rent your RV on Outdoorsy. Listing is FREE and takes just a minute.',
    id: 'cQdMQu',
  });

  return (
    <>
      <HeadMeta title={title} description={description} />
      <main className="bg-canvas-100">
        <Hero />
        <HostBenefits />
        <StartListingForm />
        <Testimonials />
        <HostExperiences />
        <HostingOverview />
        <HostingTools />
        <FAQs />
        <HostingBlogs />
      </main>
    </>
  );
};

export default BecomeAHost;
